import { AdminUserPermissionsEnum, GenderEnum, VerificationTypesEnum } from '@/lib/enum.ts';
import { useRequestGetDashboardData } from '@/hooks/httpRequest';
import ContentPageGroupItem from './ContentPageGroupItem';
import { SecuredComponent } from '@/components/hoc';
import ContentPageGroup from './ContentPageGroup';
import { useUserConnected } from '@/hooks';
import routes from '@/lib/routes';
import {
	MessageCircleWarning,
	UserRoundSearch, ScanBarcode,
	BadgeCheck,
	Settings,
	Wallet,
	Image,
	Undo2,
	Text,
	Megaphone,
	Calendar as CalendarLucide
} from 'lucide-react';

const ContentPage = () => {

	const { data, isLoading } = useRequestGetDashboardData();
	const { hasPermissions } = useUserConnected();

	let countReports = data.reports;

	if (hasPermissions(AdminUserPermissionsEnum.HANDLE_ADMIN_REVIEW_REQUEST)) {
		countReports += ((data?.review?.photo ?? 0) + (data?.review?.id ?? 0));
	}

	return (
		<div className='flex flex-col space-y-6 md:space-y-10'>
			{/* Group : Vérifications */}
			<SecuredComponent
				permissionsRequired={[
					AdminUserPermissionsEnum.CERTIFICATION,
					AdminUserPermissionsEnum.PHOTO_VERIF,
					AdminUserPermissionsEnum.BIO_VERIF,
					AdminUserPermissionsEnum.HISTORY,
					AdminUserPermissionsEnum.REPORT
				]}>
				<ContentPageGroup title='Vérifications'>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.CERTIFICATION]}>
						<ContentPageGroupItem
							to={{ pathname: routes.nav.certifications, search: `gender=${GenderEnum.MALE}` }}
							label={'Certifications'}
							value={data.id}
							isLoading={isLoading}
							icon={BadgeCheck} />
					</SecuredComponent>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.PHOTO_VERIF]}>
						<ContentPageGroupItem
							to={`${routes.nav.verifications}?gender=${GenderEnum.MALE}`}
							label={'Photos'}
							value={data.photo}
							isLoading={isLoading}
							icon={Image} />
					</SecuredComponent>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.BIO_VERIF]}>
						<ContentPageGroupItem
							to={routes.nav.bioReview}
							label={'Bio'}
							value={data.bio}
							isLoading={isLoading}
							icon={Text} />
					</SecuredComponent>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.HISTORY]}>
						<ContentPageGroupItem
							to={routes.nav.verificationsHistory.getHref(VerificationTypesEnum.PROFILE_PHOTO)}
							value={-1}
							label={'Historique'}
							icon={Undo2} />
					</SecuredComponent>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.REPORT]}>
						<ContentPageGroupItem
							to={routes.nav.reports.getHref({ tab: 'users' })}
							label={'Signalements'}
							value={countReports}
							isLoading={isLoading}
							icon={MessageCircleWarning} />
					</SecuredComponent>
				</ContentPageGroup>
			</SecuredComponent>
			{/* Group : Gestion */}
			<SecuredComponent
				permissionsRequired={[
					AdminUserPermissionsEnum.ACCOUNTING_MANAGER,
					AdminUserPermissionsEnum.REFERRAL,
					AdminUserPermissionsEnum.USERS,
					AdminUserPermissionsEnum.MARKETING,
					AdminUserPermissionsEnum.PROMOTION,
					AdminUserPermissionsEnum.EVENT
				]}>
				<ContentPageGroup title='Gestion'>
					<SecuredComponent
						permissionsRequired={[
							AdminUserPermissionsEnum.ACCOUNTING_MANAGER,
						]}>
						<ContentPageGroupItem
							to={routes.nav.accounting.overview.getHref()}
							label={'Comptabilité'}
							icon={Wallet} />
					</SecuredComponent>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.REFERRAL]}>
						<ContentPageGroupItem
							to={`${routes.nav.referral}?sortType=DESC&sortBy=referralCount`}
							label={'Parrainage'}
							icon={ScanBarcode} />
					</SecuredComponent>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.USERS]}>
						<ContentPageGroupItem
							to={routes.nav.users.getHref()}
							label={'Utilisateurs'}
							icon={UserRoundSearch} />
					</SecuredComponent>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.MARKETING, AdminUserPermissionsEnum.PROMOTION]}>
						<ContentPageGroupItem
							to={
								hasPermissions(AdminUserPermissionsEnum.MARKETING)
									? routes.nav.marketing.messages.getHref()
									: routes.nav.marketing.promotions.getHref()
							}
							label={'Marketing'}
							icon={Megaphone} />
					</SecuredComponent>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.EVENT]}>
						<ContentPageGroupItem
							to={routes.nav.events.getHref()}
							label={'Événements'}
							icon={CalendarLucide} />
					</SecuredComponent>
				</ContentPageGroup>
			</SecuredComponent>
			{/* Group : Autres */}
			<SecuredComponent
				permissionsRequired={[
					AdminUserPermissionsEnum.SETTINGS,
					AdminUserPermissionsEnum.STATS
				]}>
				<ContentPageGroup title='Autres'>
					<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.SETTINGS]}>
						<ContentPageGroupItem
							to={routes.nav.settings.permissions.getHref()}
							label={'Paramètres'}
							icon={Settings} />
					</SecuredComponent>
				</ContentPageGroup>
			</SecuredComponent>
		</div>
	);

};

export default ContentPage;
